module.exports = __webpack_public_path__ + "static/don17-4ee144498cbece486aa625b60c02ea4e.jpg";